export default __webpack_public_path__ + "static/media/test-management.038f698b.svg";